import { render, staticRenderFns } from "./GoodsFormStep1.vue?vue&type=template&id=133d9ad4&scoped=true&"
import script from "./GoodsFormStep1.vue?vue&type=script&lang=js&"
export * from "./GoodsFormStep1.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFormStep1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GoodsFormStep1.vue?vue&type=style&index=1&id=133d9ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d9ad4",
  null
  
)

export default component.exports